var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[(_vm.isForm)?_c('ForgotPasswordForm',{on:{"success":function($event){_vm.isForm = false}}}):_c('ForgotPasswordSuccess')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }